module.exports = __webpack_public_path__ + "img/goods14-5.d26a988d.jpg";